import { render, staticRenderFns } from "./AudioSlide.vue?vue&type=template&id=5f4dd504&scoped=true"
import script from "./AudioSlide.vue?vue&type=script&lang=js"
export * from "./AudioSlide.vue?vue&type=script&lang=js"
import style0 from "./AudioSlide.vue?vue&type=style&index=0&id=5f4dd504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4dd504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4dd504')) {
      api.createRecord('5f4dd504', component.options)
    } else {
      api.reload('5f4dd504', component.options)
    }
    module.hot.accept("./AudioSlide.vue?vue&type=template&id=5f4dd504&scoped=true", function () {
      api.rerender('5f4dd504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/layerContent/AudioSlide.vue"
export default component.exports